/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: OptionsIcon.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  13.03.23 2:27 pm.
 * Last modified: 13.03.23 2:27 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

const LanguagesIcon = ({ selected, onClick }: { selected?: boolean; onClick?: () => void }) => {
    return (
        <div onClick={onClick} className={selected ? 'egt_settings_tab_selected' : ''}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" id="settingsLanguage">
                <g id="Group_2811" data-name="Group 2811" transform="translate(-758 -796)">
                    <path
                        id="Path_4680"
                        data-name="Path 4680"
                        d="M42.5,0A42.5,42.5,0,1,1,0,42.5,42.5,42.5,0,0,1,42.5,0Z"
                        transform="translate(758 796)"
                        fill="#040404"
                    />
                    <g id="language_black_24dp" transform="translate(772.365 811)">
                        <path id="Path_4644" data-name="Path 4644" d="M0,0H55V55H0Z" fill="rgba(0,0,0,0)" />
                        <path
                            id="Path_4645"
                            data-name="Path 4645"
                            d="M24.894,2a22.917,22.917,0,1,0,22.94,22.917A22.905,22.905,0,0,0,24.894,2ZM40.775,15.75h-6.76a35.863,35.863,0,0,0-3.162-8.158A18.4,18.4,0,0,1,40.775,15.75ZM24.917,6.675a32.282,32.282,0,0,1,4.377,9.075H20.54A32.282,32.282,0,0,1,24.917,6.675ZM7.179,29.5a18.888,18.888,0,0,1-.6-4.583,18.888,18.888,0,0,1,.6-4.583h7.746a37.847,37.847,0,0,0-.321,4.583,37.847,37.847,0,0,0,.321,4.583Zm1.879,4.583h6.76a35.862,35.862,0,0,0,3.163,8.158,18.3,18.3,0,0,1-9.923-8.158Zm6.76-18.333H9.058a18.3,18.3,0,0,1,9.923-8.158,35.863,35.863,0,0,0-3.163,8.158Zm9.1,27.408a32.282,32.282,0,0,1-4.377-9.075h8.754A32.282,32.282,0,0,1,24.917,43.158ZM30.279,29.5H19.554a33.717,33.717,0,0,1-.367-4.583,33.424,33.424,0,0,1,.367-4.583H30.279a33.424,33.424,0,0,1,.367,4.583A33.717,33.717,0,0,1,30.279,29.5Zm.573,12.742a35.863,35.863,0,0,0,3.162-8.158h6.76A18.4,18.4,0,0,1,30.852,42.242ZM34.908,29.5a37.847,37.847,0,0,0,.321-4.583,37.847,37.847,0,0,0-.321-4.583h7.746a18.888,18.888,0,0,1,.6,4.583,18.888,18.888,0,0,1-.6,4.583Z"
                            transform="translate(2.583 2.583)"
                            className="settingsIcons"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default LanguagesIcon;
